import axios from "axios";
import { getAllEntriesFromDB } from "./db";

export const authHeaders = () => {
  const authToken =
    localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"));
  return {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
};

export const authHeaders2 = () => {
  const authToken =
    localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"));
  return {
    Authorization: `Bearer ${authToken}`,
  };
};

export const refreshToken = async () => {
  let user = "";
  user =
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"));
  if (!user || !user?.username || !user?.password) {
    const userData = await getAllEntriesFromDB("userData");
    user = userData?.length > 0 ? userData[0] : "";
  }
  const reqObj = {
    username: user?.username,
    password: user?.password,
    type: "TM",
  };
  if (!reqObj?.username || !reqObj?.password) {
    throw "Unauthorized";
  }
  return axios.post(`${process.env.REACT_APP_BASE_URL}/login`, reqObj);
};

const Axios = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}`,
});

export default Axios;
